import {keepPreviousData, useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {httpGetMailBatches, HttpGetMailBatchesParams} from '@/features/mailer/http/mailer.http'

// History is a monitoring view: the global 10-min staleTime would keep
// serving a stale (even empty) list on every tab switch right after a send,
// with no visible network activity. Always refetch on mount and poll while
// any batch is still being worked ("In corso" progresses live).
export const useMailBatches = (params: HttpGetMailBatchesParams) =>
    useQuery({
        queryKey: [QUERY_KEYS.MAILER_BATCHES, params],
        queryFn: () => httpGetMailBatches(params),
        placeholderData: keepPreviousData,
        staleTime: 0,
        refetchInterval: query => (query.state.data?.data.some(batch => batch.counts.pending > 0) ? 5000 : false)
    })
